import { render, staticRenderFns } from "./chinh-sach-panel.vue?vue&type=template&id=6e6ee77f"
import script from "./chinh-sach-panel.vue?vue&type=script&lang=js"
export * from "./chinh-sach-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports